import { produce } from 'immer';

import * as actions from './actions';

export const defaultState = {
    startX: 0,
    deltaX: 0,
    startY: 0,
    deltaY: 0,
    started: false
};

export const reducer = (reducerSuffix) => produce((draftState, action) => {
    switch (action.type) {
        case actions.SLIDER_SWIPE_RESET_TO_DEFAULT:
        case actions.SLIDER_SWIPE_RESET_TO_DEFAULT + reducerSuffix: {
            Object.assign(draftState, defaultState);

            break;
        }

        case actions.SLIDER_SWIPE_UPDATE:
        case actions.SLIDER_SWIPE_UPDATE + reducerSuffix: {
            Object.assign(draftState, action.payload);

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
